module.exports = __webpack_public_path__ + "media/flags/ai-5d494fc6.svg";